import clsx from "clsx";

import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { CircleArrowButton } from "../icons";
import { ProfilePicture } from "../ProfilePicture/ProfilePicture";
import { OrganizationDropdown } from "./OrganizationDropdown/OrganizationDropdown";

interface IProps {
  showNav: () => void;
  isMinimized: boolean;
  hovered: boolean;
}

const SidebarLogo: React.FC<IProps> = ({ showNav, isMinimized, hovered }) => {
  const { currentOrganization } = useOrganizationContext();
  return (
    <div className="app-sidebar-logo px-6">
      {isMinimized && !hovered ? (
        <ProfilePicture label={currentOrganization?.name || " "} />
      ) : (
        <OrganizationDropdown />
      )}

      <span
        className={clsx(
          "app-sidebar-toggle btn btn-icon position-absolute top-50 start-100 translate-middle rotate",
          { active: !isMinimized },
        )}
        onClick={showNav}
      >
        <CircleArrowButton />
      </span>
    </div>
  );
};

export { SidebarLogo };
